import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import Textfield from "@/components/inputs/Textfield.tsx";

const ContactsForm = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={"w-full max-w-[31.25rem] space-y-7 rounded-5 bg-surface p-[1.875rem] max-lg:max-w-none"}>
      <div>
        <h2 className={"text-2xl font-semibold max-lg:text-lg/6"}>{t("Contacts.feedback")}</h2>
        <p className={"mt-4 text-on-surface max-lg:mt-1"}>{t("Contacts.feedback-description")}</p>
      </div>
      <form>
        <Textfield placeholder={t("Contacts.your-feedback")} rows={7} className={"outline-transparent"} />
        <Button type={"submit"} className={"mt-5"}>
          {t("Actions.send")}
        </Button>
      </form>
    </div>
  );
};

export default ContactsForm;
